import { useEffect, useState } from "react";
import { Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import LoginModal from "./components/Modals/LoginModal";
import SignUpModal from "./components/Modals/SignUpModal";
import NavBar from "./components/NavBar/NavBar";
import { User } from "./models/user";
import * as UserApi from "./network/user_api";
import GamePage from "./pages/GamePage/GamePage";
import GameSetsPage from "./pages/GameSetsPage/GameSetsPage";
import LandingPage from "./pages/LandingPage/LandingPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import BadgesPage from "./pages/BadgesPage/BadgesPage";
import "./styles/global.scss";
import LeaderboardPage from "./pages/LeaderboardPage/LeaderboardPage";
import StorePage from "./pages/StorePage/StorePage";
import Cookies from "js-cookie";

function App() {
  const [loggedInUser, setLoggedInUser] = useState<User | null>(null);

  const [showSigUpModal, setShowSigUpModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    async function fetchLoggedInUser() {
      try {
        const user = await UserApi.getLoggedInUser();
        if (user?.activeSplashScreen) {
          Cookies.set("activeSplashScreen", user.activeSplashScreen);
        }
        if (user?.activeProfileImage) {
          Cookies.set("activeProfileImage", user.activeProfileImage);
        }
        if (user?.activeCardTheme) {
          Cookies.set("activeCardTheme", user.activeCardTheme);
        }
        setLoggedInUser(user);
      } catch (error) {
        console.error(error);
      }
    }
    fetchLoggedInUser();
  }, []);

  return (
    <BrowserRouter>
      <div>
        <NavBar
          loggedInUser={loggedInUser}
          onSignedUpClicked={() => setShowSigUpModal(true)}
          onLoginClicked={() => setShowLoginModal(true)}
          onLogoutSuccessful={() => setLoggedInUser(null)}
        />
        <div className={"fullPageContainer"}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route
              path="/gameSets"
              element={<GameSetsPage loggedInUser={loggedInUser} />}
            />
            <Route
              path="/gameSets/:gamesetId"
              element={<GameSetsPage loggedInUser={loggedInUser} />}
            />
            <Route
              path="/profile"
              element={<ProfilePage loggedInUser={loggedInUser} />}
            />
            <Route
              path="/gameSets/:gamesetId/game"
              element={<GamePage loggedInUser={loggedInUser} />}
            />
            <Route
              path="/badges"
              element={<BadgesPage loggedInUser={loggedInUser} />}
            />
            <Route
              path="/leaderboard"
              element={<LeaderboardPage loggedInUser={loggedInUser} />}
            />
            <Route
              path="/store"
              element={<StorePage loggedInUser={loggedInUser} />}
            />
            <Route path="/*" element={<NotFoundPage />} />
          </Routes>
        </div>
        {showSigUpModal && (
          <SignUpModal
            onDismiss={() => setShowSigUpModal(false)}
            onSignUpSuccessful={(user) => {
              setLoggedInUser(user);
              setShowSigUpModal(false);
            }}
          />
        )}
        {showLoginModal && (
          <LoginModal
            onDismiss={() => setShowLoginModal(false)}
            onLoginSuccessful={(user) => {
              setLoggedInUser(user);
              setShowLoginModal(false);
            }}
          />
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
